import Offer from '../../Models/Offer'
import './OfferBox.css'

interface Props
{
	data: Offer
	onSelected: (value: boolean) => void
	selected: boolean
}

  
const OfferBox = (props: Props) =>
{
	const onClick = () =>
	{
		props.onSelected(!props.selected)
	}
	
	return (
		<div className="offer-container clickable" onClick={onClick} style={{ backgroundColor: props.data?.background_color }} >
			<div className="offer-circle">
				{props.selected ? <div className="offer-red-circle" /> : <div />}
			</div>
			<img className="offer-image" alt='' src={`${props.data?.image_url}`} />
			<div className="offer-text-container">
				<div className='offer-title'>{props.data?.ad_title}</div>
				<div className="offer-first-third-line">internet fino</div>
				<div className="offer-second-line">a <b style={{ color: props.data?.price_color }}>{props.data?.ad_speed}</b></div>
				<div className="offer-first-third-line">A</div>
				<div className="offer-fourth-line" style={{ color: props.data?.price_color }}>{props.data?.ad_price}</div>
				<div className="offer-subtitle">{props.data?.ad_subtitle}</div>
				<div className='offer-extras' style={{ color: props.data?.description_color }}>
					<div className='offer-extra'>{props.data?.ad_line_1}</div>
					<div className='offer-extra'>{props.data?.ad_line_2}</div>
					<div className='offer-extra'>{props.data?.ad_line_3}</div>
				</div>
			</div>
		</div>
	)
}

export default OfferBox
